import React from "react";
import { useIntl } from "react-intl";
import { connect, useDispatch } from "react-redux";
import Button from "../../DesignSystem/Button/Button";

const PermissionAlertPopup = () => {
	const dispatch = useDispatch();
	const { formatMessage } = useIntl();

	const onClickRefresh = () => {
		window.location.reload();
	};

	return (
		<div className="user-details flex direction-col align-items-start text-left">
			<div className="text text-header--7 text-left">
				{formatMessage({ id: "shared.permission.camera.title" })}
			</div>

			<div className="text text-body--3 text-left mt-8">
				{formatMessage({ id: "shared.permission.camera.description" })}
			</div>

			<div className="info-section mt-16">
				<div className="text text-body--4 text-bold">
					{formatMessage({ id: "shared.permission.camera.info.title" })}
				</div>

				<ul>
					<li>
						<div className="text text-body--4">
							{formatMessage({ id: "shared.permission.camera.info.step1" })}
						</div>
					</li>
					<li>
						<div className="text text-body--4">
							{formatMessage({ id: "shared.permission.camera.info.step2" })}
						</div>
					</li>
					<li>
						<div className="text text-body--4">
							{formatMessage({ id: "shared.permission.camera.info.step3" })}
						</div>
					</li>
				</ul>
			</div>

			<div className="flex direction-row align-items-center justify-content-end mt-16">
				<Button className="button-primary ml-8 px-12" label="shared.actions.refresh" onClick={onClickRefresh} />
			</div>
		</div>
	);
};

export default connect((state) => ({}), {})(PermissionAlertPopup);
